import { render, staticRenderFns } from "./ViewSocialBan.vue?vue&type=template&id=01657ceb&"
import script from "./ViewSocialBan.vue?vue&type=script&lang=js&"
export * from "./ViewSocialBan.vue?vue&type=script&lang=js&"
import style0 from "./ViewSocialBan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports